import { TopTen } from "$gql/queries/general/TopTen.gen";
import Button from "components/core/Button/Button";
import Modal from "components/Modal/Modal";
import SearchBox from "components/Search/SearchBox";
import Link from "next/link";
import React, { useState } from "react";
import { useMutationBundle, useQueryBundle } from "source/hooks";
import Top10Section from "./Top10Section";
import styles from "./VoteForPerksModal.module.scss";
import { CreateUserBrandInterest } from "$gql/mutations/general/CreateUserBrandInterest.gen";

type Props = {
  visible: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  userId: number;
};

const VoteForPerksModal = (props: Props) => {
  const [selectedTicker, setSelectedTicker] = useState<string>("");
  const [hasPerks, setHasPerks] = useState<boolean>(false);
  const topTenQuery = useQueryBundle(TopTen);
  const [addInterest] = useMutationBundle(CreateUserBrandInterest);

  const resultSelected = (ticker: string, hasPerks: boolean) => {
    addInterest({
      variables: {
        userId: props.userId,
        tickerSymbol: ticker,
      },
    });

    setHasPerks(hasPerks);
    setSelectedTicker(ticker);
  };

  const voteForAnotherBrand = () => {
    setSelectedTicker("");
    setHasPerks(false);
  };

  return (
    <Modal
      visible={props.visible}
      onClose={props.onClose}
      className={styles.modal}
    >
      {!selectedTicker || hasPerks ? (
        <>
          <div className={styles.container}>
            <h2>{props.title ?? "Vote for your favorites"}</h2>
            <p className={styles.description}>
              {props.description ??
                "Have a favorite brand that doesn't currently offer perks on TiiCKER? Vote for your favorites to see perks from them in the future!"}
            </p>
          </div>
          <SearchBox
            specifiedSearch="Brand"
            removePopular
            placeholder="Search Brands"
            inputClass={styles.input}
            containerClass={styles.inputContainer}
            resultClass={styles.resultContainer}
            brandResultClickOverride={resultSelected}
            searchButtonTillSmall
          />
          {selectedTicker !== "" && hasPerks && (
            <div className={styles.fullContainer}>
              <div className={styles.resultContainer}>
                <p className={styles.hasPerks}>
                  Tii:{selectedTicker} currently offers perks already.{" "}
                  <Link href={`brand/${selectedTicker}`}>
                    <a>View {selectedTicker}</a>
                  </Link>
                </p>
              </div>
            </div>
          )}

          <Top10Section
            results={
              topTenQuery.state === "DONE"
                ? topTenQuery.data.topTen?.map((x) => {
                    return {
                      brandName: x.name,
                      tickerSymbol: x.tickerSymbol,
                    };
                  }) ?? []
                : []
            }
          />
        </>
      ) : (
        <>
          <div className={styles.container}>
            <h2>Thank You!</h2>
            <p className={styles.description}>
              Thank you for showing your support for Tii:{selectedTicker}! In
              the mean time, check out our voting page to see some of the most
              requested brands.
            </p>
            <div className={styles.buttonContainer}>
              <Button
                type="primary"
                className={styles.button}
                href={`brand/${selectedTicker}`}
              >
                View Tii:{selectedTicker}
              </Button>
              <Button
                type="secondary"
                className={styles.button}
                onClick={voteForAnotherBrand}
              >
                Vote for another brand
              </Button>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default VoteForPerksModal;
